export const MEDIA_OBJECT_CREATE_RESET = 'MEDIA_OBJECT_CREATE_RESET'
export const MEDIA_OBJECT_CREATE_SET_CREATED = 'MEDIA_OBJECT_CREATE_SET_CREATED'
export const MEDIA_OBJECT_CREATE_SET_ERROR = 'MEDIA_OBJECT_CREATE_SET_ERROR'
export const MEDIA_OBJECT_CREATE_SET_VIOLATIONS = 'MEDIA_OBJECT_CREATE_SET_VIOLATIONS'
export const MEDIA_OBJECT_CREATE_TOGGLE_LOADING = 'MEDIA_OBJECT_CREATE_TOGGLE_LOADING'
